import React, { useContext, useEffect, useState } from "react";
import { Button, Container } from "@material-ui/core";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import moment from "moment-timezone";
import ThemeTable from "../../../../components/Table/ThemeTable";
import TableToolbar from "../../../../components/Table/TableToolbar";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import SingleSelect from "../../../../components/SelectField/SingleSelect";
import { getAllEmployee } from "../../../../services/apiservices/employee";
import { getSuppliesByDate } from "../../../../services/apiservices/supplies";
import dayjs from "dayjs";
import { getClientsList } from "../../../../services/apiservices/client";
import { FormatedDates } from "../../../../services/helpers";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";
import { Link, useNavigate } from "react-router-dom";
import styles from "../../Report.module.scss";
import { useMediaQuery } from "@mui/material";
import * as Excel from 'exceljs';
import { downloadExcel, downloadPDF } from "../../DownloadReportUtils";
import AuthContext from "../../../../hooks/authContext";
import ActionRender from "../../ActionRender";
import { getSettings } from "../../../../services/apiservices/settings";

const SupplyReport = () => {
    const csvHeaders = [
        "Client Name",
        "Date",
        "Supply Id",
        "Created By",
        "Order Status",
        "Order Items",
        "Item Status"
      ];
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [allUsers, setAllUsers] = useState(null);
    const [clientName, setClientName] = useState("All");
    const [settingsData, setSettingsData] = useState();
    const [clientNameList, setClientNameList] = useState([
        { label: "All", value: "All" },
    ]);
    const [clientsList, setClientList] = useState([]);
    const [clientsListMaster, setClientsListMaster] = useState([]);
    const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
    const [status, setStatus] = useState("All");
    const [statusList, setStatusList] = useState([{ label: "All", value: "All" }]);
    const [priority, setPriority] = useState("All");
    const [priorityList, setPriorityList] = useState([{ label: "All", value: "All" }]);
    const [isLoading, setIsLoading] = useState(false);
    const [expandedRow, setExpandedRow] = useState(null);
    const isMobile = useMediaQuery('(max-width:767px)');
    const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
    const auth = useContext(AuthContext);
    const localClientID = localStorage.getItem('clientId');
    const localCompanyId = localStorage.getItem('companyId');
    const { setReportData } = auth || {};
    const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
    const clientId = localClientID ? localClientID : auth?.userProfile?.client;
    let navigate = useNavigate();


    const getColumns = () => {
        const columns = [
            {
                id: "clientName",
                numeric: false,
                disablePadding: false,
                label: "Client Name",
                isSortable: false,
            },
            {
                id: "dateOfRequest",
                numeric: false,
                disablePadding: false,
                label: "Date",
                isSortable: false,
            },
            {
                id: "supplyId",
                numeric: false,
                disablePadding: false,
                label: "Supply Id",
                isSortable: false,
            },
            {
                id: "createdBy",
                numeric: false,
                disablePadding: false,
                label: "Created By",
                isSortable: false,
            },
            {
                id: "status",
                numeric: false,
                disablePadding: false,
                label: "Order Status",
                isSortable: false,
            },
            {
                id: "itemsQty",
                numeric: false,
                disablePadding: false,
                label: "Order Items",
                isSortable: false,
            },
            {
                id: "itemStatus",
                numeric: false,
                disablePadding: false,
                label: "Item Status",
                isSortable: false,
            },
            {
                id: "Action",
                numeric: false,
                disablePadding: false,
                label: "Action",
                isSortable: false,
            },
        ];
        return columns;
    };

      const fetchInitialData = async () => {
        const [settingsRes] = await Promise.all([
          new Promise((resolve) =>
            getSettings("client_settings", companyId, (res) => resolve(res?.data))
          ),
        ]);
        const filteredData = settingsRes?.filter(
          (item) => !item.deleted
        );
        setSettingsData(filteredData?.length ? filteredData : []);
      };

      useEffect(() => {
        fetchInitialData();
      }, []);

    const handleclientNameChange = (e) => {
        const str = e.target.value;
        setClientName(str);
        if (str === "All") {
            setClientList(clientsListMaster);
        } else {
            setClientList(() =>
                clientsListMaster.filter((itme) => {
                    let returnFlg = true;
                    if (str !== "All" && returnFlg) {
                        returnFlg = itme?.clientId === str;
                    }
                    return returnFlg;
                })
            );
        }
    };

    const handelStatusChange = (e) => {
        const str = e.target.value;
        setStatus(str);

        if (str === "All") {
            setClientList(clientsListMaster);
        } else {
            setClientList(() =>
                clientsListMaster.filter((itme) => {
                    let returnFlg = true;
                    if (clientName !== "All" && returnFlg) {
                        returnFlg = itme?.clientId === clientName;
                    }
                    if (str !== "All" && returnFlg) {
                        returnFlg = itme?.status === str;
                    }
                    return returnFlg;
                })
            );
        }
    };

    const handlePriorityChange = (e) => {
        const str = e.target.value;
        setPriority(str);

        if (str === "All") {
            setClientList(clientsListMaster);
        } else {
            setClientList(() =>
                clientsListMaster.filter((itme) => {
                    let returnFlg = true;
                    if (clientName !== "All" && returnFlg) {
                        returnFlg = itme?.clientId === clientName;
                    }
                    if (str !== "All" && returnFlg) {
                        returnFlg = itme?.status === status;
                    }
                    if (str !== "All" && returnFlg) {
                        returnFlg = itme?.priority === str;
                    }
                    return returnFlg;
                })
            );
        }
    };

const getDatatoDownload = (rcellItem) => {
        let clientCSV = [];
        if (!Array.isArray(rcellItem)) {
            clientCSV = clientsList?.filter(
                (item) => item?.clientNameId === rcellItem?.clientNameId
            );
            clientCSV = clientCSV?.flatMap((item) => {
                const supplyItemsRows = item?.supplyItems?.map((itm) => {
                    return ['', '', '', '', '', `${itm.title}(${itm.qty})`, `${itm?.status === true ? "Ordered" : itm?.status}`]
                });
                return [
                    [
                        item?.clientName,
                        item?.dateOfRequest,
                        item?.supplyId,
                        item?.createdBy,
                        item?.status,
                        item?.itemsQty,
                        ''
                    ],
                    ...supplyItemsRows
                ];
            });
        } else {
            clientCSV = rcellItem?.flatMap((item) => {
                const supplyItemsRows = item?.supplyItems?.map((itm) => {
                    return ['', '', '', '', '', `${itm.title}(${itm.qty})`, `${itm?.status === true ? "Ordered" : itm?.status}`]
                });
                return [
                    [
                        item?.clientName,
                        item?.dateOfRequest,
                        item?.supplyId,
                        item?.createdBy,
                        item?.itemsQty,
                        ''
                    ],
                    ...supplyItemsRows
                ];
            });
        }
        return clientCSV;
    }


    const getDatatoFullDownload = (rcellItem) => {
        if (rcellItem) {
            return [
                rcellItem?.clientName,
                rcellItem?.dateOfRequest,
                rcellItem?.supplyId,
                rcellItem?.createdBy,
                rcellItem?.status,
                rcellItem?.itemsQty,
                ''
            ];
        } else {
            return [
                rcellItem?.clientName,
                rcellItem?.dateOfRequest,
                rcellItem?.supplyId,
                rcellItem?.createdBy,
                rcellItem?.status,
                rcellItem?.itemsQty,
                ''
            ];
        }
    };

    const downloadForExcel = async (rcellItem, emailSend) => {
        const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
        let wb = new Excel.Workbook();
        let ws = wb.addWorksheet('Supply Report');
        
        const clientCSV = getDatatoDownload(rcellItems);
        let fileName;
        if (Array.isArray(rcellItem)) {
            fileName = `SupplyReport_${rcellItem[0]?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        } else {
            fileName = `SupplyReport_${rcellItem?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        }
        return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend)
    }

    const downloadForPDF = async (rcellItem, emailSend) => {
        const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
        const clientCSV = getDatatoDownload(rcellItems);
        let fileName;
        if (Array.isArray(rcellItem)) {
            fileName = `SupplyReport_${rcellItem[0]?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        } else {
            fileName = `SupplyReport_${rcellItem?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        }
        const logo = settingsData?.[0]?.companyLogo;
        return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
    }

    const setDownloadCSVData = (event, done, rcellItem) => {
        const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
        const clientCSV = getDatatoDownload(rcellItems);

        const reportName = "Supply Report";
        const clientName = Array.isArray(rcellItem) ? `${rcellItem[0]?.clientName}` : `${rcellItem?.clientName}`;
        const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;

        // Create the report details rows
        const reportDetails = [
            [`Client Name: ${clientName}`],
            [`Report Name: ${reportName}`],
            [`Report Period: ${reportPeriod}`],
            [],
            [...csvHeaders],
            ...clientCSV
        ];

        // Set the CSV data
        setClientListCSV(reportDetails);
        done();
    };

    const downloadForFullPDF = async (emailSend) => {
        const clientCSV = clientsList?.flatMap((item) => {
            const mainRow = getDatatoFullDownload(item);
            const supplyItemsRows = item.supplyItems?.map(itm => {
                return ['', '', '', '', '', `${itm.title}(${itm.qty})`, `${itm?.status === true ? "Ordered" : itm?.status}`]
            });
            return [mainRow, ...supplyItemsRows];
        });

        let clientNamefordwonLoad = 'All';
        if (clientName !== 'All') {
            clientNamefordwonLoad = clientNameList?.filter((item) => item.value === clientName)[0].label;
        }

        let fileName = `SupplyReport_${clientNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        const logo = settingsData?.[0]?.companyLogo;
        return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
    };


    const downloadForFullExcel = async (emailSend) => {
        let wb = new Excel.Workbook();
        let ws = wb.addWorksheet('Supply Report');
        let clientNamefordwonLoad = 'All'

        const clientCSV = clientsList?.flatMap((item) => {
            const mainRow = getDatatoFullDownload(item);
            const supplyItemsRows = item.supplyItems?.map(itm => {
                return ['', '', '', '', '', `${itm.title}(${itm.qty})`, `${itm?.status === true ? "Ordered" : itm?.status}`]
            });
            return [mainRow, ...supplyItemsRows];
        });

        if (clientName !== 'All') {
            clientNamefordwonLoad = clientNameList?.filter((item) => item.value === clientName)[0].label
        }
        let fileName = `SupplyReport_${clientNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
        return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend)
    }

    const handleEmailIconClick = async (rcellItem) => {
        const emailSend = true;
        let name;
        if (Array.isArray(rcellItem)) {
        name = rcellItem[0]?.clientName;
        } else {
        name = rcellItem?.clientName;
        }

        const [excelBlob, pdfBlob] = await Promise.all([
        downloadForExcel(rcellItem, emailSend),
        downloadForPDF(rcellItem, emailSend)
        ]);
        // Convert the Excel blob to a base64-encoded string
        const reader = new FileReader();
        reader.readAsDataURL(excelBlob);
        reader.onloadend = function () {
        const base64Data = reader.result;
        setReportData((prev) => ({
            ...prev,
            FileName: "SupplyReport",
            ReportsName: "Client Report",
            Name: name,
            Date: startDate,
            EndDate: endDate,
            pdf: pdfBlob,
            storedData: base64Data,
            fullData: "",
            fullExcelData: ""
        }));
        navigate("/emailreports");
        };
    };

  const handelEmailFullReport = async () => {
    const emailSend = true;

    let clientNamefordwonLoad = 'All'

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList?.filter((item) => item.value === clientName)[0]?.label
    }

    const [fullReport, fullExcelReport] = await Promise.all([
      downloadForFullPDF(emailSend),
      downloadForFullExcel(emailSend)
    ]);
    const reader = new FileReader();
    reader.readAsDataURL(fullExcelReport);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
      ...prev,
        FileName: "SupplyReport",
        ReportsName: "Client Report",
        Name: clientNamefordwonLoad,
        Date: startDate,
        EndDate: endDate,
        fullData: fullReport,
        fullExcelData: base64Data,
        pdf: "",
        storedData: ""
      }));
      navigate("/emailreports");
    }
  }

    useEffect(() => {
        getAllEmployee((res) => {
            if (res) {
                const data = res?.data?.filter((item)=> item.companyId === companyId);
                setAllUsers(data);
            } else {
                setAllUsers();
            }
        })
    }, []);

    useEffect(() => {
    if (startDate && endDate) {
        getReportListData(startDate, endDate);
    }
    }, [startDate, endDate]);

    const getUniqueUserIds = (supplyData) => {
        const userIds = new Set();

        supplyData?.forEach(item => {
            userIds.add(item?.clientId);
        });

        return Array.from(userIds);
    };
    const getPriorityLabel = (priority) => {
        switch (priority) {
            case "1":
                return "High";
            case "2":
                return "Medium";
            case "3":
                return "Low";
            default:
                return "Unknown";
        }
    };

    const mapWithClientIds = async (clientIds, userData) => {
        getClientsList({}, (result) => {
            const clientResult = result?.filter((item)=> item.companyId === companyId && (auth?.userProfile?.role !== "Client" || item?.id === clientId));
            const data = auth?.userProfile?.role === "Client" ? userData?.filter((item)=> item?.clientId === clientId) : userData;
            const filteredClients = clientResult?.filter((item) =>
                data?.some((data) => data.clientId === item.id)
            );
            const clients = filteredClients.map((item) => ({
                value: item.id,
                label: item.clientName,
            }))?.sort((a, b) => a?.label?.localeCompare(b?.label));
            setClientNameList([{ label: "All", value: "All" }, ...clients]);

            const uniqueStatuses = new Set();
            const uniquePriority = new Set();

            const finaleData = data?.map((resItem) => {
                const userDetails = clientResult?.filter(
                    (itm) => itm.id === resItem.clientId
                );

                let totalQuantity = 0;
                if (resItem.supplyItems) {
                    resItem.supplyItems.forEach((item) => {
                        totalQuantity += item.qty || 0;
                    });
                }

                const createdBy = allUsers?.filter((item => item.userId === resItem.createdBy));
                const date = FormatedDates(resItem.dateOfRequest);
                uniqueStatuses.add(resItem.status);
                const priority = getPriorityLabel(resItem.priority);
                uniquePriority.add(priority);

                const completedItems = resItem.supplyItems.filter((item) => item.status === "Delivered");

                const calculateCompletionPercentage = (completedData, totalData) => {
                    if (totalData === 0) {
                        return '0%'; // If there are no data, completion percentage is 0%
                    }
                    const percentage = Math.round((completedData / totalData) * 100); // Calculate completion percentage
                    return `${percentage}%`;
                };

                const completedData = completedItems.length;
                const totalData = resItem.supplyItems.length;
                const completionPercentage = calculateCompletionPercentage(completedData, totalData);

                resItem["clientName"] = userDetails[0]?.clientName;
                resItem["dateOfRequest"] = date;
                resItem["priority"] = priority;
                resItem["supplyId"] = `${String(resItem?.orderNumber).padStart(6, '0')}`;
                resItem["createdBy"] = `${createdBy[0].firstName} ${createdBy[0].lastName}`;
                resItem["itemsQty"] = `${totalQuantity}`;
                resItem["itemStatus"] = completionPercentage;
                resItem["clientNameId"] = resItem?.clientId;

                return resItem;
            });

            const statusOptions = Array.from(uniqueStatuses).map((status) => ({
                label: status,
                value: status,
            }));

            setStatusList([{ label: "All", value: "All" }, ...statusOptions]);

            const priorityOptions = Array.from(uniquePriority).map((priority) => ({
                label: priority,
                value: priority,
            }));

            setPriorityList([{ label: "All", value: "All" }, ...priorityOptions]);


            let sortedData = sortingFunction(finaleData);
            setClientsListMaster(sortedData);

            setClientList(() =>
                sortedData?.filter((itme) => {
                    let returnFlg = true;
                    if (clientName !== "All") {
                        returnFlg = itme.clientId === clientName;
                    }
                    if (status !== "All" && returnFlg) {
                        returnFlg = itme.status === status;
                    }
                    if (priority !== "All" && returnFlg) {
                        returnFlg = itme.priority === priority;
                    }
                    return returnFlg;
                })
            );
        });
    };

    const sortingFunction = (data) => {
        const result = data.sort((a, b) => {
            if (a.clientName < b.clientName) return -1;
            if (a.clientName > b.clientName) return 1;
            // If clientName is the same, sort by date
            if (a.dateOfRequest < b.dateOfRequest) return -1;
            if (a.dateOfRequest > b.dateOfRequest) return 1;
            // If clientName && Date is the same, sort by orderNumber
            if (a.orderNumber < b.orderNumber) return -1;
            if (a.orderNumber > b.orderNumber) return 1;
            return 0;
        });

        return result;
    };

    const getReportListData = async (startDt, endDt) => {
        const param = {
            startDate: `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`,
            endDate: `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`
        };
        try {
            const data = await getSuppliesByDate(param);
            const details = data?.filter((item)=> item.companyId === companyId);
            const id = getUniqueUserIds(details);

            mapWithClientIds(id, details);

        } catch (error) {
            console.error("Error fetching report list data:", error);
        }
    }

    const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
        switch (hcellItem.id) {
            case "clientName":
                if (
                    rowindex !== 0 &&
                    clientsList[rowindex - 1].clientName !== rcellItem.clientName
                ) {
                    return <div className={styles.themeCellContentt}>{rcellItem[hcellItem?.id]} </div>;
                } else if (rowindex === 0) {
                    return <div className={styles.themeCellContentt}>{rcellItem[hcellItem?.id]} </div>;
                } else {
                    return "";
                }
            case "itemsQty":
                return (
                    <div className={styles.TaskAccordion}>
                        <div className={styles.TaskSummary}>
                            {rcellItem[hcellItem?.id]}
                            <div
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setExpandedRow(expandedRow === rowindex ? null : rowindex);
                                }}
                            >
                                {expandedRow === rowindex ? <ArrowDropUpIcon className={styles.AccordionIcon} /> : <ArrowDropDownIcon className={styles.AccordionIcon} />}
                            </div>
                        </div>
                        {expandedRow === rowindex && (
                            <div className={`${styles.TaskContent} ${styles.accordiann}`}>
                                {rcellItem.supplyItems.map((data, index) => (
                                    <div key={index} className={`${styles.accordiann}`}>
                                        <div>{data.title} ({data.qty})</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                );
            case "itemStatus":
                return (
                    <div className="mt-20">
                            <div className={styles.TaskSummary}>
                                {/* {rcellItem[hcellItem?.id]} */}
                            </div>
                            {expandedRow === rowindex && (
                            <div className={`${styles.TaskContent} ${styles.accordiann}`}>
                                {rcellItem.supplyItems.map((data, index) => (
                                    <div key={index} className={`${styles.accordiann}`}>
                                        <div>{data?.status === true ? "Ordered" : data.status }</div>
                                    </div>
                                ))}
                            </div>
                        )}
                        </div>
                )
            case "Action":
                if (isMobile || isLandscape) {
                    if (rowindex === 0) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"SupplyReport"}
                            />
                        );
                    } else {
                        return null;
                    }
                } else {
                    if (
                        rowindex !== 0 &&
                        clientsList[rowindex - 1].clientName !== rcellItem.clientName
                    ) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"SupplyReport"}
                            />
                        );
                    } else if (rowindex === 0) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"SupplyReport"}
                            />
                        );
                    } else {
                        return "";
                    }
                }

            default:
                return <div className={styles.themeCellContentt}>{rcellItem[hcellItem?.id]} </div>;
        }
    };

    const tableRightComponent = () => {
        return (
            <div className="d-flex w320 editEmp issueAlign ph-8">
                <div className="mr-24 d-flex flex-center"> <FilterAltIcon className="mv-7 issueicon" /> Filters </div>
                <div className="reportsMargin mv-7">
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            label="Start Date"
                               className="customDate customDatePicker dark:[&_.MuiInputBase-input]:text-white dark:[&_.MuiInputLabel-root]:text-white"
                            value={startDate}
                            onChange={(newValue) => {
                                setStartDate(newValue);
                                // if (newValue) {
                                //     setEndDate(moment());
                                // } else {
                                //     setEndDate(null);
                                // }
                            }}
                            maxDate={moment()}
                            views={['year', 'month', 'day']}
                            inputFormat="YYYY-MM-DD"
                        />
                    </LocalizationProvider>
                </div>
                <div className="reportsMargin mv-7">
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            label="End Date"
                              className="customDate customDatePicker dark:[&_.MuiInputBase-input]:text-white dark:[&_.MuiInputLabel-root]:text-white"
                            value={endDate}
                            onChange={(newValue) => {
                                setEndDate(newValue);
                                // if (!newValue) {
                                //     setStartDate(null);
                                // }
                            }}
                            maxDate={moment()}
                            views={['year', 'month', 'day']}
                            inputFormat="YYYY-MM-DD"
                        />
                    </LocalizationProvider>
                </div>
                <div className="reportsMargin mv-7">
                    <SingleSelect
                        value={clientName}
                        className={`field reportsSingleSelect`}
                        name={"clientName"}
                        label={"Client Name"}
                        onChange={(e) => handleclientNameChange(e)}
                        options={clientNameList}
                    />
                </div>
                <div className="reportsMargin mv-7">
                    <SingleSelect
                        value={status}
                        className={`field reportsSingleSelect`}
                        name={"orderStatus"}
                        label={"Order Status"}
                        onChange={(e) => handelStatusChange(e)}
                        options={statusList}
                    />
                </div>
                <div className="reportsMargin mv-7">
                    <SingleSelect
                        value={priority}
                        className={`field reportsSingleSelect`}
                        name={"priority"}
                        label={"Priority"}
                        onChange={(e) => handlePriorityChange(e)}
                        options={priorityList}
                    />
                </div>
            </div>
        );
    };

    return (
        <Container>
            <PageTitle
                pageTitle="Supply Reports"
                showBreadcrumb={[
                    { label: "Home", to: "/" },
                    { label: "Reports" },
                    { label: "Client Reports", to: "/reports/Clientreport" }
                ]}
                BreadCrumbCurrentPageTitle={"Supply Reports"}
                showLastSeen={true}
            >
            </PageTitle>
            <div className="sectionBox2 dark:bg-[#1A1F2C] dark:text-white shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                <TableToolbar
                    rightComponent={tableRightComponent()}
                />
                <ThemeTable
                    rows={clientsList}
                    headCells={getColumns()}
                    hidePagination={true}
                    isLoading={isLoading}
                    renderRowCell={renderRowCell}
                    supplyHeader={true}
                />
            </div>
            <div className={styles.report}>
            <div className={styles.download1}>
              <EmailRoundedIcon />
              <div>
                <Link to={clientsList.length !== 0 && "/emailreports"} rel="noopener" >
                  <Button
                    className={styles.actions}
                    disabled={clientsList.length === 0}
                    onClick={() => {
                      handelEmailFullReport()
                    }}
                  >
                    Full Report
                  </Button>
                </Link>
              </div>
            </div>
            <div className={styles.download1}>
              <PictureAsPdfIcon />
              <div>
                <Button
                  className={styles.actions}
                  disabled={clientsList.length === 0}
                  onClick={() => {
                    downloadForFullPDF();
                  }}
                >
                  Download Full Report
                </Button>
              </div>
            </div>
          </div>
        </Container>
    )
}

export default SupplyReport;